// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1wFF4","name":"ConsentHeader_name__3pdbg","birthday":"ConsentHeader_birthday__3KPem","skeleton":"ConsentHeader_skeleton__2JRej"};